import { render, staticRenderFns } from "./TechnicianDetail.vue?vue&type=template&id=0b7569fa&scoped=true"
import script from "./TechnicianDetail.vue?vue&type=script&lang=ts"
export * from "./TechnicianDetail.vue?vue&type=script&lang=ts"
import style0 from "./TechnicianDetail.vue?vue&type=style&index=0&id=0b7569fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7569fa",
  null
  
)

export default component.exports